import React from 'react';
import { OptionInfo, TargetField } from '#/common/components/ColumnMapper';
import MandatoryFieldsStepBase from '../base/MandatoryFieldsStepBase';

// Define the mandatory fields
const mandatoryFields = [
  {
    key: 'third_party_id',
    label: 'Work Order ID',
    required: true,
    unique: true,
    noUnknownOption: true,
  },
  { key: 'title', label: 'Title', required: true, noUnknownOption: true },
  {
    key: 'asset_identifier',
    label: 'Asset',
    isDropdown: true,
    required: true,
    noUnknownOption: true,
    values: [
      { key: 'asset_tag', label: 'Asset Tag' },
      { key: 'serial_number', label: 'Serial Number' },
    ],
  },
  { key: 'category', label: 'Category', required: true, noUnknownOption: true },
  { key: 'description', label: 'Description', required: true, noUnknownOption: true },
] as TargetField[];

export interface MapWorkOrderMandatoryFieldsStepProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  targetDropdownSelections: Record<string, string>;
  setTargetDropdownSelections: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const MapWorkOrderMandatoryFieldsStep: React.FC<MapWorkOrderMandatoryFieldsStepProps> = ({
  csvColumns,
  mapping,
  setMapping,
  targetDropdownSelections,
  setTargetDropdownSelections,
  setIsValid,
}) => {
  return (
    <MandatoryFieldsStepBase
      csvColumns={csvColumns}
      mapping={mapping}
      setMapping={setMapping}
      targetDropdownSelections={targetDropdownSelections}
      setTargetDropdownSelections={setTargetDropdownSelections}
      setIsValid={setIsValid}
      mandatoryFields={mandatoryFields}
      uniqueFieldsMessage="This will be your unique identifier field. The value should be unique for each work order."
      uniqueFieldsMessageSeeMore="The unique identifier is used to define the work order unequivocally and if another record with the same unique identifier is uploaded, its information might update or supersede the existing record."
      warningContent={
        <>
          The Category value must match one of the existing Work Order Categories (Corrective,
          Preventive, Onboarding, Offboarding), otherwise the row will fail to import. <br />
          The Asset value must match an existing Asset by Asset Tag or Serial Number, otherwise the
          row will fail to import.
        </>
      }
    />
  );
};

export default React.memo(MapWorkOrderMandatoryFieldsStep);
